import IconButtonMUI from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useTranslationApp } from "../../lib/i18next";
import Loader from "../Loaders/Loader";

const IconButton = ({
  id = "",
  children,
  loading = false,
  loaderColor = "primary",
  sx = {},
  disabled = false,
  disableRipple = false,
  onClick = () => {},
  tooltipText,
  edge = "end",
}) => {
  const { t } = useTranslationApp();
  return (
    <Tooltip title={t(tooltipText)}>
      <span style={{ display: "inline-flex" }}>
        <IconButtonMUI
          id={id}
          disableRipple={disableRipple}
          disabled={disabled}
          onClick={(e) => onClick(e)}
          sx={{
            color: "background.paperContrastText",
            "&:hover": {
              color: "background.paperContrastText",
            },
            ...sx,
          }}
          edge={edge}
        >
          {loading && (
            <Loader hasMarginTop={false} size={20} colorCustom={loaderColor} />
          )}
          {!loading && children}
        </IconButtonMUI>
      </span>
    </Tooltip>
  );
};

export default IconButton;
